import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';
import { isMobile } from 'utils/helpers';

const propTypes = {
  logout: PropTypes.func.isRequired,
};

const CreditApplicationDeclined = ({ logout }) => (
  <div className="container">
    <div className="content-block credit-application-status credit-application-status--declined">
      <div className="credit-application-status__icon">
        <span className="icon icon--error" />
      </div>
      <span className="credit-application-status__content">
        <h3 className="txt-error">
          <FormattedMessage id="selfservice.application.declined.header" />
        </h3>
        <FormattedMessage id="selfservice.application.declined.info" tagName="p" />
        <br />
        <div>
          <Button
            type="button"
            onClick={logout}
            isFullWidth={isMobile}
          >
            <FormattedMessage id="logout.send" />
          </Button>
        </div>
      </span>
    </div>
  </div>
);

CreditApplicationDeclined.propTypes = propTypes;

export default CreditApplicationDeclined;
